export const COOKIE_MICROCOPY_DEBUG = 'microcopyDebug';
/** Cookie to store temporarily UTM params for the user */

export const COOKIE_UTM = 'sessionUtm';
export const COOKIE_USER_ID = 'userIdCookie';
export const COOKIE_USER_TOKEN = 'userTokenCookie';
export const COOKIE_BROWSER_ID = 'browserIdCookie';
export const COOKIE_USER_GROUP = 'userGroup';
/** Expiry time for the auth cookie in milliseconds */
export const COOKIE_EXPIRY_AUTH = 86400000; // 24 hours in ms

/** Expiry time for the tracking cookie in milliseconds */
export const COOKIE_EXPIRY_TRACKING = 31536000000; // 365 days in ms

/** Cookie for recently viewed cars */
export const COOKIE_RECENTLY_VIEWED = 'recentlyViewedCars';
export const COOKIE_EXPIRY_RECENTLY_VIEWED = 2592000000; // 30 days in ms

/** Cookie to store the trade-in enquiry data */
export const COOKIE_TRADE_IN_ENQUIRY = 'tradeInEnquiry';
/** Cookie to store the trade-in glass vehicle data */
export const COOKIE_TRADE_IN_VEHICLE_DATA = 'tradeInVehicleData';
export const COOKIE_EXPIRY_TRADE_IN_ENQUIRY = 86400000; // 24 hours in ms

/** Cookie to store the inspection booking data */
export const COOKIE_BOOKING_FORM = 'bookingForm';

/** Cookie to track booking submission type (expires quickly) */
export const COOKIE_BOOKING_SUBMISSION_TYPE = 'bookingSubmissionType';
export const COOKIE_EXPIRY_BOOKING_SUBMISSION_TYPE = 10000; // 10 seconds in ms

/** Cookie to store the auth form data */
export const COOKIE_AUTH_FORM = 'authFormData';
export const COOKIE_EXPIRY_AUTH_FORM = 86400000; // 24 hours in ms
